// import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';


 const TextOnlyTooltip = withStyles({
    tooltip: {
      color: "white",
      backgroundColor: "grey",
      position: 'relative',
      bottom: '20px',
      fontSize: '14px'
    }
  })(Tooltip);

  export default TextOnlyTooltip